module.exports = "/_next/static/images/phone_btn_new-4fbbc7c5ce789931762d5318a7479df2.svg";